var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.files),function(file){return _c('div',{key:file.id},[_c('ObjectFileItem',{attrs:{"file":file,"lang":_vm.lang}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }